import { Button, Modal } from 'antd'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { assetIsUsedAsImage } from '../../dux/modules/utils'
import FileUploader from '../library/FileUploader'

const IMAGE_WARNING =
  'This image is used as a preview image for one or more builders.  You may only replace it with ' +
  'another image.'
const DEFAULT_TITLE = 'Upload Assets'

const UploadModal = (props) => {
  const { modalActions, modalProps, appState, modal } = props
  const isReplaceMode = modalProps.multiple === false

  const [fileSelected, setFileSelected] = useState(false)
  const [okPressed, setOkPressed] = useState(false)
  const [editedFilename, setEditedFilename] = useState('')

  const uploadComplete = appState.uploadContinue

  useEffect(() => {
    if (uploadComplete && okPressed) {
      modalProps.callback()
      modalActions.closeModal()
    }
  }, [uploadComplete, okPressed])

  const handleOk = () => {
    if (uploadComplete) {
      modalProps.callback()
      modalActions.closeModal()
    } else {
      setOkPressed(true)
    }
  }

  const handleReplaceFileSelected = (name) => {
    setFileSelected(true)
    setEditedFilename(name)
  }

  const assetUsedAsImage = assetIsUsedAsImage(
    props.appState.editModeAsset,
    props.assets.byId,
    props.assets.relationships.assets,
  )

  return (
    <Modal
      title={modalProps.title || DEFAULT_TITLE}
      open={modal.modalOpen}
      confirmLoading={appState.asyncPending}
      maskClosable={false}
      closable={false}
      footer={[
        <Button key="cancel" onClick={modalActions.closeModal}>
          Cancel
        </Button>,
        isReplaceMode ? (
          <Button
            key="ok"
            disabled={!fileSelected || okPressed}
            onClick={handleOk}
          >
            OK
          </Button>
        ) : (
          <Button
            key="ok"
            disabled={!appState.uploadContinue}
            onClick={modalProps.callback}
          >
            CONTINUE
          </Button>
        ),
      ]}
    >
      {assetUsedAsImage ? IMAGE_WARNING : null}
      <br />
      <FileUploader
        target={'active'}
        imageOnly={props.modalProps.imageOnly || assetUsedAsImage}
        onReplaceFileSelected={isReplaceMode ? handleReplaceFileSelected : null}
        editedFilename={isReplaceMode ? editedFilename : null}
        onFilenameChange={isReplaceMode ? setEditedFilename : null}
        filenameReadOnly={okPressed && !uploadComplete}
        {...props}
      />
    </Modal>
  )
}

UploadModal.propTypes = {
  modal: PropTypes.object,
  modalActions: PropTypes.object,
  modalProps: PropTypes.object,
}

UploadModal.defaultProps = {
  modalProps: {
    multiple: true,
    type: 'asset',
    target: 'active',
  },
}
export default UploadModal
